/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import {apiLogin} from '../redux/AuthCRUD'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {useSetLang} from '../../../../_metronic/i18n/Metronici18n'
const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

/*
Formik+YUP+Typescript:
https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const intl = useIntl()
  const setLang = useSetLang()
  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email(intl.formatMessage({id: 'AUTH.VALIDATION.INVALID'}, {name: 'Email'}))
      .required(intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED'}, {name: 'Email'})),
    password: Yup.string().required(
      intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED'}, {name: 'Password'})
    ),
  })

  const initialValues = {
    email: '',
    password: '',
  }
  const [capsLockOn, setCapsLockOn] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        apiLogin(values.email, values.password)
          .then(({data}) => {
            setLoading(false)
            if (data.response.token) {
              if (process.env.REACT_APP_MAINTENANCE_MODE == 'true') {
                localStorage.setItem('maintenanceMode', 'true')
              }
              localStorage.setItem('k', btoa(data.response.token))
              localStorage.setItem('uid', btoa(data.response.userId))
              localStorage.setItem('p', btoa(JSON.stringify(data.response.role)))
            }
            dispatch(auth.actions.login(data))
            if (data.response && data.response.defaultLanguage) {
              const defualtLanguage = data.response.defaultLanguage.toLowerCase()

              switch (defualtLanguage) {
                case 'english':
                  setLang('en')
                  break
                case 'swedish':
                  setLang('sv')
                  break
                case 'finnish':
                  setLang('fin')
                  break
                case 'norwegian':
                  setLang('no')
                  break
                default:
                  setLang('en')
              }
            }

            // dispatch(auth.actions.setUser(data.response))
          })
          .catch((error) => {
            setLoading(false)
            setSubmitting(false)
            setStatus(intl.formatMessage({id: 'AUTH.VALIDATION.INVALID_LOGIN'}))
          })
      }, 1000)
    },
  })

  const checkCapslockStatus = (event: any) => {
    setCapsLockOn(event.getModifierState('CapsLock'))
  }

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>
          {intl.formatMessage({id: 'AUTH.LOGIN.SIGN_INTO_IFLEETCAM_CLOUD'})}
        </h1>
      </div>
      {/* begin::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>
          {intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
        </label>
        <input
          placeholder={intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span className='text text-danger' role='alert'>
              {formik.errors.email}
            </span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>
              {intl.formatMessage({id: 'AUTH.INPUT.PASSWORD'})}
            </label>
            {/* end::Label */}
            {/* begin::Link */}
            {/* <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{ marginLeft: '5px' }}
            >
              Forgot Password ?
            </Link> */}
            {/* end::Link */}
          </div>
        </div>
        <div className='d-flex flex-column gap-2'>
          <div className='position-relative'>
            <input
              type={showPassword ? 'text' : 'password'}
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid'
                // {
                //   'is-caps': capsLockOn,
                // },
                // {
                //   'is-invalid': formik.touched.password && formik.errors.password,
                // },
                // {
                //   'is-valid': formik.touched.password && !formik.errors.password,
                // }
              )}
              onKeyDown={checkCapslockStatus}
            />
            <button
              type='button'
              className='btn btn-link position-absolute top-50 end-0 translate-middle-y me-3'
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <i className='text-dark fs-4 fa fa-eye-slash'></i>
              ) : (
                <i className='text-dark fs-4 fa fa-eye'></i>
              )}
            </button>
          </div>
          <div className='d-flex flex-column'>
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span className='text text-danger d-flex align-items-center gap-2' role='alert'>
                    {/* <i className="bi bi-x text-danger" style={{ fontSize: '18px' }}></i> */}
                    {formik.errors.password}
                  </span>
                </div>
              </div>
            )}
            {capsLockOn && (
              <div className='d-flex align-items-center gap-2 text-muted'>
                {/* <i className="fs-5 bi bi-exclamation-circle"></i> */}
                {intl.formatMessage({id: 'WARNING.ACTIVE_CAPS'})}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className='indicator-label'>
              {intl.formatMessage({id: 'AUTH.CONTINUE.BUTTON'})}
            </span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'AUTH.GENERAL.PLEASE_WAIT'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        {/* end::Google link */}
      </div>
      {/* end::Action */}

      <div className='fv-row'>
        <div className='flex-stack text-end'>
          {/* begin::Link */}
          <Link
            to='/auth/forgot-password'
            className='link-primary fs-6'
            style={{marginLeft: '5px'}}
            reloadDocument
          >
            {intl.formatMessage({id: 'AUTH.GENERAL.FORGOT_BUTTON'})} ?
          </Link>
          {/* end::Link */}
        </div>
      </div>
    </form>
  )
}
